module.exports = __webpack_public_path__ + "static/media/cat.95fe2288.svg";